var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#292D32",
    fillOpacity: 0.04
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0705 12.4026C22.8978 11.7606 22.3869 11.2542 21.7369 11.0806C20.5616 10.7692 15.8462 10.7692 15.8462 10.7692C15.8462 10.7692 11.1332 10.7692 9.9555 11.0806C9.30791 11.2518 8.79703 11.7583 8.62194 12.4026C8.30774 13.5676 8.30774 15.9999 8.30774 15.9999C8.30774 15.9999 8.30774 18.4323 8.62194 19.5973C8.79463 20.2392 9.30551 20.7457 9.9555 20.9192C11.1332 21.2307 15.8462 21.2307 15.8462 21.2307C15.8462 21.2307 20.5616 21.2307 21.7369 20.9192C22.3845 20.7481 22.8954 20.2416 23.0705 19.5973C23.3847 18.4323 23.3847 15.9999 23.3847 15.9999C23.3847 15.9999 23.3847 13.5676 23.0705 12.4026Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3399 18.242L18.2567 15.9999L14.3399 13.7579V18.242Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/IconYoutube.c5c7b428f4ee1c693b786739e653ced6.svg";
export { ForwardRef as ReactComponent };